import {
  InfoCard,
  Link,
  Progress,
  ResponseErrorPanel,
} from '@backstage/core-components';
import { useApi } from '@backstage/core-plugin-api';
import { Box, Grid, Tooltip } from '@material-ui/core';
import useAsync from 'react-use/lib/useAsync';
import { stringifyEntityRef } from '@backstage/catalog-model';
import { useEntity } from '@backstage/plugin-catalog-react';
import { awardsApiRef } from '@internal/plugin-neo4j-awards';
import type { Award } from '@internal/plugin-neo4j-awards-common';

export const UserAchievementsCard = () => {
  const { entity } = useEntity();
  const awardsApiClient = useApi(awardsApiRef);

  const {
    value: awards,
    loading,
    error,
  } = useAsync(async (): Promise<Award[]> => {
    return awardsApiClient.getAwards('', '', [], [stringifyEntityRef(entity)]);
  }, []);

  if (loading) {
    return <Progress />;
  }

  if (error) {
    return <ResponseErrorPanel error={error} />;
  }

  const awardsList = Array.isArray(awards) ? awards : [];

  if (awardsList.length === 0) {
    return null;
  }

  return (
    <InfoCard title="Achievements">
      <Grid container spacing={2} alignItems="flex-start">
        {awardsList.map(award => (
          <Grid item xs={12} sm={4} md={4} lg={4} key={award.uid}>
            <Link to={`/awards/view/${award.uid}`}>
              <Box display="flex" flexDirection="column" alignItems="center">
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  style={{ height: 120, width: '100%', overflow: 'hidden' }}
                >
                  <Tooltip title={award.name}>
                    <img
                      src={award.image}
                      alt={award.name}
                      style={{
                        maxHeight: '100%',
                        maxWidth: '100%',
                        height: 'auto',
                        width: 'auto',
                      }}
                    />
                  </Tooltip>
                </Box>
              </Box>
            </Link>
          </Grid>
        ))}
      </Grid>
    </InfoCard>
  );
};
